import { Dialog, DialogBody, DialogHeader } from '@repo/ui';
import { dateUtil } from '@xtnd/web/shared';

import MatterLedgerReport from '../reports/MatterLedgerReport';
import { LedgerReportForm } from '../../types';

type Props = {
  values: LedgerReportForm;
  isOpen: boolean;
  matterDisplayNumber?: string;
  onClose: () => void;
};

export default function MatterLedgerReportModal({ values, matterDisplayNumber, isOpen, onClose }: Props) {
  const dateFrom = values.dateRange.from
    ? dateUtil.formatDate(new Date(values.dateRange.from), dateUtil.DateFormat.US)
    : null;
  const dateTo = values.dateRange.to
    ? dateUtil.formatDate(new Date(values.dateRange.to), dateUtil.DateFormat.US)
    : null;

  return (
    <Dialog open={isOpen} onClose={onClose} size="full">
      <DialogHeader>
        <h1>{`Matter Ledger Report - ${matterDisplayNumber ?? ''} ${dateFrom && dateTo ? `(${dateFrom} - ${dateTo})` : ''}`}</h1>
      </DialogHeader>

      <DialogBody className="max-h-[90vh] overflow-y-auto">
        <MatterLedgerReport formValues={values} />
      </DialogBody>
    </Dialog>
  );
}
